import { createRouter, createWebHistory } from "vue-router";
import { useAuth } from "../features/auth/store";
export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    {
      path: "/cms-preview",
      component: () => import("../features/cms/CmsPreview.vue"),
      meta: { public: true },
    },
    {
      path: "/login",
      component: () => import("../features/auth/LoginPage.vue"),
      meta: { public: true },
    },
    {
      path: "/print/:kind(package|hotel|tour)",
      component: () => import("../features/offers/PrintEntry.vue"),
    },
    {
      path: "/",
      component: () => import("./AppShell.vue"),
      children: [
        {
          path: "content/page/:id",
          name: "cms-page-id",
          component: () => import("../features/cms/CmsPage.vue"),
        },
        {
          path: "content/item/:id",
          name: "cms-item",
          component: () => import("../features/cms/CmsPage.vue"),
        },
        {
          path: "content/:slug",
          name: "cms-page-slug",
          component: () => import("../features/cms/CmsPage.vue"),
        },
        { path: "", component: () => import("../features/cms/CmsPage.vue") },
        {
          path: "search/:kind(packages|hotels|villas)",
          component: () => import("../features/search/SearchPage.vue"),
        },
        {
          path: "offers/tours",
          component: () =>
            import("../features/offers/tours/TourOffersPage.vue"),
        },
        {
          path: "offers",
          component: () => import("../features/offers/OffersPage.vue"),
        },
        {
          path: "bookings",
          component: () => import("../features/bookings/BookingsPage.vue"),
        },
        {
          path: "bookings/:id(\\d+)",
          component: () =>
            import("../features/bookings/BookingDetailsPage.vue"),
        },
        { path: "bus", component: () => import("../features/bus/BusPage.vue") },
        {
          path: "tours",
          component: () => import("../features/tours/ToursPage.vue"),
        },
        {
          path: "tours/:tourId(\\d+)/:date/book",
          component: () => import("../features/tours/TourBookingPage.vue"),
        },
        { path: "account", component: () => import("./AccountPage.vue") },
        {
          path: "contact",
          component: () => import("../features/cms/CmsPage.vue"),
        },
      ],
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});
router.beforeEach(async (to) => {
  if (to.meta.public) return;
  const auth = useAuth();
  await auth.restore();
  if (!auth.user) return { path: "/login", query: { redirect: to.fullPath } };
});
window.addEventListener("hello:session-expired", () => {
  const auth = useAuth();
  auth.user = null;
  if (router.currentRoute.value.path !== "/login")
    void router.push({
      path: "/login",
      query: { expired: "1", redirect: router.currentRoute.value.fullPath },
    });
});
